module.exports = __webpack_public_path__ + "img/Jancsik Péter.05092fd5.png";